import { Button, message, Modal, Upload } from 'antd'
import { UploadOutlined } from '@ant-design/icons'
import { useEffect, useState } from 'react'
import { uploadImg } from '../../api/api'
import request from '../../utils/request'
import { upload } from '@testing-library/user-event/dist/upload'
import { getBase64 } from '../../utils/getbase64'
import handleFileInUploading from '../../utils/cos'
import compressImg from '../../utils/compress'
import handleFileInCompressUploading from '../../utils/cos_compress'

import { DndContext, PointerSensor, useSensor } from '@dnd-kit/core'
import {
  arrayMove,
  SortableContext,
  useSortable,
  verticalListSortingStrategy,
} from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'

//实现拖拽效果
const DraggableUploadListItem = ({ originNode, file }) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({
    id: file.uid,
  })
  const style = {
    transform: CSS.Translate.toString(transform),
    transition,
    cursor: 'move',
  }
  return (
    <div
      ref={setNodeRef}
      style={style}
      // prevent preview event when drag end
      className={isDragging ? 'is-dragging' : ''}
      {...attributes}
      {...listeners}
    >
      {/* hide error tooltip when dragging */}
      {file.status === 'error' && isDragging
        ? originNode.props.children
        : originNode}
    </div>
  )
}

const UploadlistTypeMultiplePicture = (props) => {
  const [fileList, setFileList] = useState([])
  const [thumbUrl, setThumbUrl] = useState()
  //向父组件传值
  const deliverUrl = props.deliverUrl
  console.log('fileList', fileList)
  console.log(props.images)
  const max = props.max
  const name = props.name
  //图片预览
  const [previewOpen, setPreviewOpen] = useState(false)
  const [previewImage, setPreviewImage] = useState('')
  const [previewTitle, setPreviewTitle] = useState('')
  const [isRemove, setIsRemove] = useState(false)

  useEffect(() => {
    const images = props.images.map((item, index) => {
      return {
        uid: index,
        name: `${name}${index + 1}`,
        status: 'done',
        url: item.thumbnail,
      }
    })
    console.log('images', images)
    setFileList(images)
  }, [])

  useEffect(() => {
    //不知道为什么，向上拖动时会触发a标签的跳转，向下拖动则不会，尝试好久之后决定用土办法，直接移除了href属性，不会影响图片的预览效果
    let imgItem = document.querySelectorAll('.ant-upload-list-item-image')
    let imgItemName = document.querySelectorAll('.ant-upload-list-item-name')
    for (let a = 0; a < imgItem.length; a++) {
      imgItem[a].removeAttribute('href')
      imgItemName[a].removeAttribute('href')
    }

    const newDeliverUrl = fileList.map((item) => {
      return {
        thumbnail: item.url,
        origin: item.url,
      }
    })
    deliverUrl(() => newDeliverUrl)
  }, [fileList])

  const myUpload = (file) => {
    //上传完成后的回调函数
    const afterUpload = (origin, thumbnail, file) => {
      setIsRemove(false)
      const aporigin =
        'https://' + origin.replace('cos.accelerate', 'cos-website.ap-shanghai')
      const apthumbnail =
        'https://' +
        thumbnail.replace('cos.accelerate', 'cos-website.ap-shanghai')
      const newList = fileList
      newList.push({
        uid: newList.length + 1,
        url: aporigin,
        name: `${name}${newList.length + 1}`,
        status: 'done',
      })
      setFileList(newList)

      //可以集成在useeffect里
      deliverUrl((pre) => {
        return [...pre, { thumbnail: apthumbnail, origin: aporigin }]
      })

      if ((aporigin ?? false) && aporigin !== '') {
        message.success('图片上传成功！')
      }
    }
    handleFileInCompressUploading(file.file, afterUpload)
  }

  //删除图片后的回调函数
  const handleChange = ({ file, fileList }) => {
    if (file.status === 'removed') {
      const removeId = file.uid
      const newList = fileList.filter((item) => item.uid !== removeId)
      setFileList(newList)

      //可以集成在useeffect里
      const deliverList = []
      newList.forEach((element) => {
        deliverList.push({ thumbnail: element.url, origin: element.url })
      })
      deliverUrl(deliverList)
    }
  }

  function beforeUpload(file) {
    const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png'
    if (!isJpgOrPng) {
      message.error('只能上传JPG或PNG文件!')
      return false
    }
    const isLt100M = file.size / 1024 / 1024 < 100
    if (!isLt100M) {
      message.error('图片大小需小于100MB!')
      return false
    }

    return isJpgOrPng && isLt100M
  }

  // 方法：图片预览
  const handlePreview = async (file) => {
    console.log(file.url, file.preview)
    if ((!file.url && !file.preview) ?? true) {
      file.preview = await getBase64(file.originFileObj)
    }
    // console.log('smyhvae handlePreview:' + JSON.stringify(file))
    setPreviewImage(file.url || file.preview)
    setPreviewOpen(true)
    setPreviewTitle(
      file.name || file.url.substring(file.url.lastIndexOf('/') + 1)
    )
  }

  const handleCancel = () => setPreviewOpen(false)

  //拖拽相关
  const sensor = useSensor(PointerSensor, {
    activationConstraint: {
      distance: 1,
    },
  })
  const onDragEnd = ({ active, over }) => {
    if (active.id !== over?.id) {
      setFileList((prev) => {
        const activeIndex = prev.findIndex((i) => i.uid === active.id)
        const overIndex = prev.findIndex((i) => i.uid === over?.id)
        return arrayMove(prev, activeIndex, overIndex)
      })
    }
  }

  // 阻止a标签冒泡？或者直接把a标签的href给删除
  return (
    <>
      <DndContext sensors={[sensor]} onDragEnd={onDragEnd}>
        <SortableContext
          items={fileList.map((i) => i.uid)}
          strategy={verticalListSortingStrategy}
        >
          <Upload
            multiple
            key={props.index + 'roomsDetail'}
            maxCount={max}
            beforeUpload={beforeUpload}
            onChange={handleChange}
            customRequest={myUpload}
            fileList={fileList}
            onPreview={handlePreview}
            listType="picture"
            className="upload-list-inline"
            itemRender={(originNode, file) => (
              <DraggableUploadListItem originNode={originNode} file={file} />
            )}
            // onRemove={handleRemove}
          >
            {fileList.length >= max ? null : (
              <Button icon={<UploadOutlined />}>上传图片</Button>
            )}
          </Upload>

          <Modal
            open={previewOpen}
            title={previewTitle}
            footer={null}
            onCancel={handleCancel}
          >
            <img
              alt="example"
              style={{
                width: '100%',
              }}
              src={previewImage}
            />
          </Modal>
        </SortableContext>
      </DndContext>
    </>
  )
}

export default UploadlistTypeMultiplePicture
